<template>
  <div class="video-player">
    <div v-if="ready" class="container">
      <video id="videoPlayer" width="650" controls  autoplay>
        <source :src="`${config.api}/video/${video.id}?${videoHeaders}`" type="video/mp4" />
      </video>
    </div>
    <div v-else-if="average" class="container">
      <div class="loader">
        <span class="timer">estimate: {{average}}s</span>
        <div class="current" :style="loaderStyle"></div>
      </div>
      <br>
      <div class="trace">
        <div v-for="line in trace" :key="line" class="line">
          {{line}}
        </div>
      </div>
    </div>
    <div v-else>

    </div>
  </div>
</template>

<script>

const password = localStorage.getItem('password');
const authorization = localStorage.getItem('authorization');

import config from '../config'

export default {
  name: 'VideoPlayer',
  data() {
    return {
      ready: false,
      video: {},
      average: 0,
      start: 0,
      interval: null,
      findingVideo: 0,
      downloadingVideo: 0,
      decryptingVideo: 0,
      trace: [],
      breathDuration: 0,
      config
    }
  },
  methods: {
    prepare() {
      const { id } = this.$route.params;

      this.axios.put(`${config.api}/prepare/${id}`, {}, {
        headers: {
          authorization,
          password
        }
      })
        .then(result => {
          this.video = result.data;
          this.ready = true;

          clearInterval(this.interval);
        })

      this.axios.get(`${config.api}/preparation_time`, {
        headers: {
          authorization,
          password
        }
      })
        .then(result => {
          this.average = Math.round(result.data.average / 1000);
          this.start = 0;
          this.interval = setInterval(() => {
            this.start += 1;
          }, 1000);

          this.findingVideo = this.average / 3;
          this.downloadingVideo = this.findingVideo * 2;
          this.decryptingVideo = this.findingVideo * 3;

          setTimeout(() => {
            this.trace.push('Finding video...')
          }, (0) * 1000);
          setTimeout(() => {
            this.trace.push('DeQrypting video...')
          }, (this.downloadingVideo - this.findingVideo)  * 1000);
          setTimeout(() => {
            this.trace.push('Downloading video...')
          }, (this.decryptingVideo - this.findingVideo) * 1000);
        })
    },
  },
  computed: {
    videoHeaders: function() {
      const password_ = password || 'password';
      const authorization_ = authorization || 'authorization';

      return `password=${password_}`;
    },
    loaderStyle: function() {
      let ratio = (this.start / this.average * 100);
      if (ratio > 100) ratio = 100;
      if (ratio < 5) ratio = 3;
      return `width:${ratio}%;`;
    }
  },
  created() {
    this.prepare();
  }
}
</script>

<style scoped>

.loader {
  width: 100%;
  height: 20px;
  background-color: rgb(94, 94, 94);
  border-radius: 6px;

  position: relative;
}

.current {
  height: 100%;
  border-radius: 6px;

  transition: 4s;

  animation: glow 3s infinite;
}

@keyframes glow {
  0% {
    background-color: rgb(0, 82, 0);
  }
  50% {
    background-color: rgb(0, 145, 0);
  }
  100% {
    background-color: rgb(0, 82, 0);
  }
}

.timer {
  position: absolute;
  width: 100%;
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/components/Watch.vue